import React from 'react';
import _ from 'lodash';
import { Stack, Card, CardHeader, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Modal, Box, Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { useParameterizedQuery, useMutation } from 'react-fetching-library';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Done from '@mui/icons-material/Done';
import DoneAll from '@mui/icons-material/DoneAll';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { getInvoiceDocuments, submitInvoiceAction, changeDGCSStatusAction } from '../../../../../../services/request';
import { formatDate } from '../../../../../../services/functions';
import Iconify from '../../../../../../components/Iconify';
import { ConfirmDialog } from '../../../../../../components/ConfirmDialog';
import { AlertDialogContainer } from '../../../../../../components/others/AlertDialogContainer';
import { setOrder } from '../../../../../../services/redux-actions';
import SendDocumentModal from '../../../../settlement/document/SendDocumentModal';

import { DocumentBase } from './documents/DocumentBase';
import SendTpayLinkModal from './SendTpayLinkModal';
import PDFPreviewModal from '../DocumentAndNotificationsTab/PDFPreviewModal';
import toast from 'react-hot-toast';

const PaymentSummary = () => {
  const { season, module } = useSelector(state => state.app);
  const { order } = useSelector(state => state.orderData);
  const dispatch = useDispatch();
  const { query } = useParameterizedQuery(getInvoiceDocuments);
  const { mutate } = useMutation(submitInvoiceAction);
  const dgcsStatusMutation = useMutation(changeDGCSStatusAction);
  const [openModal, setOpenModal] = React.useState(false);
  const [openTpayModal, setOpenTpayModal] = React.useState(false);
  const [anchorReceiptEl, setAnchorReceiptEl] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [type, setType] = React.useState({});
  const [editData, setEditData] = React.useState([]);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const [idToDelete, setIdToDelete] = React.useState(null);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const [confirmStatusChange, setConfirmStatusChange] = React.useState(false);
  const [tempData, setTempData] = React.useState({});
  const [sendData, setSendData] = React.useState({});
  const [openSendModal, setOpenSendModal] = React.useState(false);

  const handleOpenSendModal = row => {
    setOpenSendModal(true);
    setSendData(row);
  };

  const handleCloseSendModal = () => {
    setOpenSendModal(false);
    setSendData({});
  };

  const open = Boolean(anchorEl);
  const openReceipt = Boolean(anchorReceiptEl);

  const getDocumentClick = async (id, fileName, preview = false) => {
    const { payload, error, loading } = await query(id);
    if (!error && !loading) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${fileName}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      }

    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };


  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleReceiptClick = event => {
    setAnchorReceiptEl(event.currentTarget);
  };

  const handleReceiptClose = () => {
    setAnchorReceiptEl(null);
  };

  const handelModalOpen = type => {
    setType(type);
    setOpenModal(true);
    handleClose();
  };

  const handleOpenTpayModal = () => setOpenTpayModal(true);
  const handleCloseTpayModal = () => setOpenTpayModal(false);

  const getFileName = type => {
    if (type === 1) {
      return 'Faktura';
    } else if (type === 2) {
      return 'Faktura korygująca';
    } else if (type === 3) {
      return 'Faktura proforma';
    } else if (type === 4) {
      return 'Faktura do paragonu';
    } else if (type === 5) {
      return 'Paragon';
    } else if (type === 6) {
      return 'Paragon korygujący';
    } else if (type === 7) {
      return 'Faktura marża';
    } else if (type === 8) {
      return 'Paragon marża';
    } else if (type === 9) {
      return 'Faktura do paragonu marża';
    } else if (type === 10) {
      return 'Faktura zaliczkowa';
    } else if (type === 11) {
      return 'Nota obciążeniowa';
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', idToDelete);
    if (!error) {
      const orderCopy = order;
      const invoices = _.filter(orderCopy.invoices, obj => obj.id !== idToDelete);
      orderCopy.invoices = invoices;
      setIdToDelete(null);
      dispatch(setOrder(orderCopy));
      setSeverity('success');
      setTitle('Usunięto dokument');
      setMessage('');
      setShowAlert(true);
    } else {
      setSeverity('error');
      setTitle('Nie udało się usunąć dokumentu');
      setMessage('');
      setShowAlert(true);
    }
  };

  const submitCallback = (method, invoice) => {
    const orderCopy = order;
    if (method === 'create') {
      orderCopy.invoices = [...orderCopy.invoices, invoice];
      dispatch(setOrder(orderCopy));
      setSeverity('success');
      setTitle('Dodano dokument');
      setMessage('');
      setShowAlert(true);
    } else if (method === 'edit') {
      const invoices = orderCopy.invoices;
      const idx = _.findIndex(invoices, obj => obj.id == invoice.id);
      invoices[idx] = invoice;
      orderCopy.invoices = invoices;
      dispatch(setOrder(orderCopy));
      setSeverity('success');
      setTitle('Edytowano dokument');
      setMessage('');
      setShowAlert(true);
    }
  };

  const openConfirmationWindow = (row, bool) => {
    setTempData({ row, 'markAsReady': bool });
    setConfirmStatusChange(true);
  };
  const handleChangeDGCSStatus = async () => {
    const { error, payload } = await dgcsStatusMutation.mutate(tempData.row.id, tempData);
    if (!error) {
      const orderCopy = order;
      const idx = _.findIndex(orderCopy.invoices, obj => obj.id == payload.id);
      orderCopy.invoices[idx] = payload;
      dispatch(setOrder(orderCopy));
      setSeverity('success');
      setTitle(tempData.markAsReady ? 'Dokument jest teraz na liście oczekujących do pobrania przez system DGCS' : 'Usunięto dokument z listy oczekujących na transfer DGCS');
      setMessage('');
      setShowAlert(true);
    } else {
      setSeverity('error');
      setTitle('Nie udało się zaktualizować statusu dokumentu');
      setMessage('');
      setShowAlert(true);
    }
  };


  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Stack direction="row" spacing={2} sx={{ m: 2 }}>
        <TableContainer component={Card} sx={{ flex: '1 1 32%' }}>
          <Stack direction="row">
            <CardHeader title="Pozycje zamówienia" sx={{ mb: 1, mt: -1 }} />
            <Button variant="contained" sx={{ mb: 1, mt: 1 }} onClick={handleOpenTpayModal}>Wyślij link do płatności tpay</Button>
          </Stack>
          <Table aria-label="spanning table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Cena (zł)</TableCell>
                <TableCell align="center">Nazwa</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order.products.map(row => (
                <TableRow key={row.id}>
                  <TableCell align="center">{row.gross_value}</TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer component={Card} sx={{ flex: '1 1 68%' }}>
          <Stack direction="row">
            <CardHeader title="Dokumenty" sx={{ mb: 1, mt: -1 }} />
            <Button
              id="receipt-basic-button"
              aria-controls={openReceipt ? 'receipt-basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={openReceipt ? 'true' : undefined}
              onClick={handleReceiptClick}
              variant="contained"
              startIcon={<AddIcon />}
              sx={{ mb: 1, mt: 1 }}
            >
            Dodaj paragon
            </Button>
            <Menu
              id="receipt-basic-menu"
              anchorEl={anchorReceiptEl}
              open={openReceipt}
              onClose={handleReceiptClose}
              MenuListProps={{
                'aria-labelledby': 'receipt-basic-button'
              }}
            >
              <MenuItem onClick={() => handelModalOpen({ name: 'Paragon', code: 5 })}>Paragon</MenuItem>
              <MenuItem onClick={() => handelModalOpen({ name: 'Paragon korygujący', code: 6 })}>Paragon korygujący</MenuItem>
              {/* <MenuItem onClick={() => handelModalOpen({ name: 'Paragon marża', code: 8 })}>Paragon marża</MenuItem> */}
            </Menu>
            <Button
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              variant="contained"
              startIcon={<AddIcon />}
              sx={{ mb: 1, mt: 1, ml: 1 }}
            >
            Dodaj fakturę
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
            >
              <MenuItem onClick={() => handelModalOpen({ name: 'Faktura', code: 1 })}>Faktura</MenuItem>
              <MenuItem onClick={() => handelModalOpen({ name: 'Faktura korygująca', code: 2 })}>Faktura korygująca</MenuItem>
              <MenuItem onClick={() => handelModalOpen({ name: 'Faktura proforma', code: 3 })}>Faktura proforma</MenuItem>
              <MenuItem onClick={() => handelModalOpen({ name: 'Faktura do paragonu', code: 4 })}>Faktura do paragonu</MenuItem>
              {/* <MenuItem onClick={() => handelModalOpen({ name: 'Faktura marża', code: 7 })}>Faktura marża</MenuItem> */}
              {/* <MenuItem onClick={() => handelModalOpen({ name: 'Faktura do paragonu marża', code: 9 })}>Faktura do paragonu marża</MenuItem> */}
              <MenuItem onClick={() => handelModalOpen({ name: 'Faktura zaliczkowa', code: 10 })}>Faktura zaliczkowa</MenuItem>
              <MenuItem onClick={() => handelModalOpen({ name: 'Nota obciążeniowa', code: 11 })}>Nota obciążeniowa</MenuItem>
            </Menu>
          </Stack>
          <Table aria-label="spanning table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Numer</TableCell>
                <TableCell>Rodzaj płatności</TableCell>
                <TableCell>Kwota</TableCell>
                <TableCell>Typ dokumentu</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order.invoices.map(row => (
                <TableRow key={row.id}>
                  <TableCell>
                    <Stack direction="row">
                      <Tooltip title="Podglad">
                        <IconButton variant="contained" color="primary" onClick={() => getDocumentClick(row.id, getFileName(row.type), true)}>
                          <RemoveRedEyeIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Wyślij">
                        <IconButton variant="contained" color="primary" onClick={() => handleOpenSendModal(row)}>
                          <ForwardToInboxIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Pobierz PDF">
                        <IconButton variant="contained" color="secondary" onClick={() => getDocumentClick(row.id, getFileName(row.type))}>
                          <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />
                        </IconButton>
                      </Tooltip>
                      { row.dgcs_sent && !row.dgcs_update_required
                        ? <Tooltip title="Dokument wysłany">
                          <Box mt={0.8} ml={0.8}><DoneAll color="primary" /></Box>
                        </Tooltip>
                        : row.dgcs_status === 1
                          ? <Tooltip title="Oznacz jako gotowe do wysyłki z DGCS">
                            <IconButton
                              color="secondary"
                              onClick={() => openConfirmationWindow(row, true)}
                            >
                              <Done />
                            </IconButton>
                          </Tooltip> : [2, 4].includes(row.dgcs_status)
                            ? <Tooltip title="Odznacz jako gotowe do wysyłki z DGCS">
                              <IconButton
                                color="primary"
                                onClick={() => openConfirmationWindow(row, false)}
                              >
                                <Done color="green" />
                              </IconButton>
                            </Tooltip> : <Tooltip title="Dokument w trakcie przetwarzania">
                              <Box mt={0.8} ml={0.8}><Done /></Box>
                            </Tooltip>
                      }
                      { row.can_edit
                        ? <>
                          <Tooltip title="Edytuj">
                            <IconButton variant="contained" color="primary" onClick={() => {
                              setOpenModal(true);
                              setType(row.type_and_code);
                              setEditData(row);
                            }}>
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Usuń">
                            <IconButton variant="contained" color="error" onClick={() => {
                              setConfirmDeleteOpen(true);
                              setIdToDelete(row.id);
                            }}>
                              <DeleteIcon />
                            </IconButton>
                          </ Tooltip>
                        </> : null
                      }
                    </Stack>
                  </TableCell>
                  <TableCell>{formatDate(row.issue_date)}</TableCell>
                  <TableCell>{row.number}</TableCell>
                  <TableCell>{row.payment_method}</TableCell>
                  <TableCell>{row.total_due_difference}</TableCell>
                  <TableCell>{getFileName(row.type)}</TableCell>
                  <TableCell>{row.dgcs_status_display}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }} align="left">Do zapłaty: {order.order_value}</TableCell>
                <TableCell colSpan={1}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }} align="left">Zapłacono: {order.sum_of_advances}</TableCell>
                <TableCell colSpan={1}></TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold' }} align="left">Do zapłaty pozostało: {order.left_to_pay}</TableCell>
                <TableCell colSpan={1}></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Modal open={openModal} onClose={() => {
          setOpenModal(false);
          setEditData([]);
        }} >
          <Box>
            <DocumentBase closeDialog={() => {
              setOpenModal(false);
              setEditData([]);
            }} type={type} order={order} season={season} module={module} editData={editData} submitCallback={submitCallback} />
          </Box>
        </Modal>
        <SendTpayLinkModal open={openTpayModal} handleClose={handleCloseTpayModal} />
      </Stack>
      <ConfirmDialog
        title="Usunąć Dokument?"
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={handleDelete}
      >
        Czy na pewno chcesz usunąć ten dokument?
      </ConfirmDialog>
      <ConfirmDialog
        title={tempData.markAsReady ? 'Oznaczyć jako gotowe do wysyłki do systemu DGCS?' : 'Odznaczyć jako gotowe do wysyłki do systemu DGCS?'}
        open={confirmStatusChange}
        setOpen={setConfirmStatusChange}
        onConfirm={handleChangeDGCSStatus}
      >
        {tempData.markAsReady ? 'Czy na pewno chcesz oznaczyć ten dokument jako gotowy do wysyłki do systemu DGCS?' : 'Dokument czeka na pobranie przez system DGCS. Czy na pewno chcesz go odznaczyć?'}
      </ConfirmDialog>
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
      <SendDocumentModal
        open={openSendModal}
        handleClose={handleCloseSendModal}
        data={sendData}
      />
    </>
  );
};


export default PaymentSummary;
